// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, {FC} from "react";
// import { useSelector } from "react-redux";
// import { ... } from "antd";
// Icons:
import AppIcons from "./AppIcons.tsx";

// redux-hooks:
// import { useAppSelector, useAppDispatch } from "../libs/redux-hooks.ts";

// Reducers:
// import { getUser } from "../reducer.ts";

const LayoutLogo:FC = () => (
  <AppIcons icopath="cg/CgMenuRound" className={"rz-txt-std"} style={{paddingTop: "6px", paddingBottom: "6px"}} attrs={{size: "1.5em"}} />
);

export default LayoutLogo;
